var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 16,
    height: 25,
    x: 0,
    y: 0,
    viewBox: "0 0 451.846 451.847",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744   L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284   c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z",
    fill: "#a5acc2",
    "data-original": "#000000",
    style: {}
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.7af8ee3c2ef60ef0fa215e5c6cf82101.svg";
export { ForwardRef as ReactComponent };